/**
 * 都道府県カテゴリー
 */
export const PrefectureCategory = {
  HOKKAIDO: '北海道',
  AOMORI: '青森県',
  IWATE: '岩手県',
  MIYAGI: '宮城県',
  AKITA: '秋田県',
  YAMAGATA: '山形県',
  FUKUSHIMA: '福島県',
  IBARAKI: '茨城県',
  TOCHIGI: '栃木県',
  GUNMA: '群馬県',
  SAITAMA: '埼玉県',
  CHIBA: '千葉県',
  TOKYO: '東京都',
  KANAGAWA: '神奈川県',
  NIIGATA: '新潟県',
  TOYAMA: '富山県',
  ISHIKAWA: '石川県',
  FUKUI: '福井県',
  YAMANASHI: '山梨県',
  NAGANO: '長野県',
  GIFU: '岐阜県',
  SHIZUOKA: '静岡県',
  AICHI: '愛知県',
  MIE: '三重県',
  SHIGA: '滋賀県',
  KYOTO: '京都府',
  OSAKA: '大阪府',
  HYOGO: '兵庫県',
  NARA: '奈良県',
  WAKAYAMA: '和歌山県',
  TOTTORI: '鳥取県',
  SHIMANE: '島根県',
  OKAYAMA: '岡山県',
  HIROSHIMA: '広島県',
  YAMAGUCHI: '山口県',
  TOKUSHIMA: '徳島県',
  KAGAWA: '香川県',
  EHIME: '愛媛県',
  KOCHI: '高知県',
  FUKUOKA: '福岡県',
  SAGA: '佐賀県',
  NAGASAKI: '長崎県',
  KUMAMOTO: '熊本県',
  OITA: '大分県',
  MIYAZAKI: '宮崎県',
  KAGOSHIMA: '鹿児島県',
  OKINAWA: '沖縄県',
} as const

export type PrefectureCategoryValue = (typeof PrefectureCategory)[keyof typeof PrefectureCategory]

export const PrefectureCategoryValues = Object.values(PrefectureCategory)

export const PrefectureCategoryLabel = {
  [PrefectureCategory.HOKKAIDO]: '北海道',
  [PrefectureCategory.AOMORI]: '青森県',
  [PrefectureCategory.IWATE]: '岩手県',
  [PrefectureCategory.MIYAGI]: '宮城県',
  [PrefectureCategory.AKITA]: '秋田県',
  [PrefectureCategory.YAMAGATA]: '山形県',
  [PrefectureCategory.FUKUSHIMA]: '福島県',
  [PrefectureCategory.IBARAKI]: '茨城県',
  [PrefectureCategory.TOCHIGI]: '栃木県',
  [PrefectureCategory.GUNMA]: '群馬県',
  [PrefectureCategory.SAITAMA]: '埼玉県',
  [PrefectureCategory.CHIBA]: '千葉県',
  [PrefectureCategory.TOKYO]: '東京都',
  [PrefectureCategory.KANAGAWA]: '神奈川県',
  [PrefectureCategory.NIIGATA]: '新潟県',
  [PrefectureCategory.TOYAMA]: '富山県',
  [PrefectureCategory.ISHIKAWA]: '石川県',
  [PrefectureCategory.FUKUI]: '福井県',
  [PrefectureCategory.YAMANASHI]: '山梨県',
  [PrefectureCategory.NAGANO]: '長野県',
  [PrefectureCategory.GIFU]: '岐阜県',
  [PrefectureCategory.SHIZUOKA]: '静岡県',
  [PrefectureCategory.AICHI]: '愛知県',
  [PrefectureCategory.MIE]: '三重県',
  [PrefectureCategory.SHIGA]: '滋賀県',
  [PrefectureCategory.KYOTO]: '京都府',
  [PrefectureCategory.OSAKA]: '大阪府',
  [PrefectureCategory.HYOGO]: '兵庫県',
  [PrefectureCategory.NARA]: '奈良県',
  [PrefectureCategory.WAKAYAMA]: '和歌山県',
  [PrefectureCategory.TOTTORI]: '鳥取県',
  [PrefectureCategory.SHIMANE]: '島根県',
  [PrefectureCategory.OKAYAMA]: '岡山県',
  [PrefectureCategory.HIROSHIMA]: '広島県',
  [PrefectureCategory.YAMAGUCHI]: '山口県',
  [PrefectureCategory.TOKUSHIMA]: '徳島県',
  [PrefectureCategory.KAGAWA]: '香川県',
  [PrefectureCategory.EHIME]: '愛媛県',
  [PrefectureCategory.KOCHI]: '高知県',
  [PrefectureCategory.FUKUOKA]: '福岡県',
  [PrefectureCategory.SAGA]: '佐賀県',
  [PrefectureCategory.NAGASAKI]: '長崎県',
  [PrefectureCategory.KUMAMOTO]: '熊本県',
  [PrefectureCategory.OITA]: '大分県',
  [PrefectureCategory.MIYAZAKI]: '宮崎県',
  [PrefectureCategory.KAGOSHIMA]: '鹿児島県',
  [PrefectureCategory.OKINAWA]: '沖縄県',
}
